/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_Save_Btn_SavingInputs */

const vi_combo_recipe_save_btn_saving = /** @type {(inputs: Combo_Recipe_Save_Btn_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang lưu...`)
};

/**

* @param {Combo_Recipe_Save_Btn_SavingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_save_btn_saving = /** @type {((inputs?: Combo_Recipe_Save_Btn_SavingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_Save_Btn_SavingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_save_btn_saving(inputs)
});